module.exports = __webpack_public_path__ + "8d52304b7074b39448184c8522f8c9c9.svg";